import Ws from "../../providers/Ws";

export default class AnalizeClienti {

    serverAddress = 'http://192.168.100.2:4444/api/'




    segmentareClienti = async () => {

        let ds = await this.analizaSumeLunarePerClienti(12)
        
        let totalGeneralSume = 1 // prevenire division by 0
        let totalGeneralNrFacturi = 1


        let rezClienti = []

        ds.forEach(c => {
            totalGeneralNrFacturi += c['data'].reduce((sum, cur) => sum + (cur['nrFacturi'] || 0), 0)
            totalGeneralSume += c['data'].reduce((sum, cur) => sum + (cur['totalDeIncasat'] || 0), 0)
        })

        const computeSegmentsSume = (val) => {
            if (Number(val)) {
                
            
                if (val < 0.2) {
                    return 'Mici'
                }
                else if (val >= 0.2 && val < 0.5) {
                    return 'Medii'
                }
                else if (val >= 0.5 && val < 0.8) {
                    return 'Mari'
                }
                else return 'F Mari'
            }
            
            else return 'Nu se poate calcula'
        }

        ds.forEach(c => {
            let _facts = Number(c['data'].reduce((sum, cur) => sum + (cur['nrFacturi'] || 0), 0))
            let _total = Number(c['data'].reduce((sum, cur) => sum + (cur['totalDeIncasat'] || 0), 0))
            
            rezClienti.push({
                client: c['client'],
                pondereNrFacturi: ( _facts / totalGeneralNrFacturi * 100 ).toFixed(2),
                pondereTotalGeneral: ( _total / totalGeneralSume * 100 ).toFixed(2),
                segment: computeSegmentsSume( _total / totalGeneralSume )
            })
        })

        let rezSegmente = []
        const segmente = ['Mici', 'Medii', 'Mari', 'F Mari', 'Nu se poate calcula']
        segmente.forEach(s => {
            let c = rezClienti.filter(c => c.segment === s)
            rezSegmente.push({
                segment: s,
                nrClienti: c.length,
                listaClienti:c
            })
        })
        

        return { segmente: rezSegmente, clienti: rezClienti }
    }

    evolutieSolduriClient = async () => {
        let ds = await this.analizaSumeLunarePerClienti(3)
        
        let rez = []
        
        ds.forEach(c => {
            if (c['data'].length >= 2) {
                if (Number(c['data'][0]['totalDeIncasat']) > Number(c['data'][1]['totalDeIncasat']) ) {
                    rez.push({
                        client: c['client'],
                        variatie: (Number(c['data'][0]['totalDeIncasat']) - Number(c['data'][1]['totalDeIncasat'])).toFixed(2),
                        evolutie:'Pozitiva'
                    })
                }
                else if (Number(c['data'][0]['totalDeIncasat']) < Number(c['data'][1]['totalDeIncasat'])) {
                    rez.push({
                        client: c['client'],
                        variatie: ( Number(c['data'][0]['totalDeIncasat']) - Number(c['data'][1]['totalDeIncasat']) ).toFixed(2),
                        evolutie: 'Negativa'
                    })
                }
                else {
                    rez.push({
                        client: c['client'],
                        variatie: Number(0).toFixed(2),
                        evolutie: 'Stationara'
                    })
                }
            }
        })

        return rez;
    }


    analizaPeSemestru = async () => {
        let ds = await this.analizaSumeLunarePerClienti(12 * 2)
       
        let cS1 = []
        let cS2 = []
        let cS3 = []
        let cS4 = []

        let an = new Date().getFullYear() - 1

        ds.forEach(c => { 
            let s1 = c.data.filter(d => Number(d['an']) === an && [1, 2, 3].includes(Number(d['luna']))) 
            if (s1.length > 0)
                cS1.push(s1)

            let s2 = c.data.filter(d => Number(d['an']) === an && [4,5,6].includes(Number(d['luna'])))
            if (s2.length > 0)
                cS2.push(s2)
            
            let s3 = c.data.filter(d => Number(d['an']) === an && [7, 8, 9].includes(Number(d['luna'])))
            if (s3.length > 0)
                cS3.push(s3)
            
            
            let s4 = c.data.filter(d => Number(d['an']) === an && [10,11,12].includes(Number(d['luna'])))
            if (s4.length > 0)
                cS4.push(s4)
        })

        let semestrul1 = {
            nrClientiFacturati: cS1.length,
            nrFacturi: cS1.reduce((sum, cur) => sum + (cur['nrFacturi'] || 0), 0),
            totalFacturat: cS1.reduce((sum, cur) => sum + (cur['totalDeIncasat'] || 0), 0),
        }

        let semestrul2 = {
            nrClientiFacturati: cS2.length,
            nrFacturi: cS2.reduce((sum, cur) => sum + (cur['nrFacturi'] || 0), 0),
            totalFacturat: cS2.reduce((sum, cur) => sum + (cur['totalDeIncasat'] || 0), 0),
        }

        let semestrul3 = {
            nrClientiFacturati: cS3.length,
            nrFacturi: cS3.reduce((sum, cur) => sum + (cur['nrFacturi'] || 0), 0),
            totalFacturat: cS3.reduce((sum, cur) => sum + (cur['totalDeIncasat'] || 0), 0),
        }

        let semestrul4 = {
            nrClientiFacturati: cS4.length,
            nrFacturi: cS4.reduce((sum, cur) => sum + (cur['nrFacturi'] || 0), 0),
            totalFacturat: cS4.reduce((sum, cur) => sum + (cur['totalDeIncasat'] || 0), 0),
        }

        return {semestrul1, semestrul2, semestrul3, semestrul4}
    }
    
    clientiActivi = async () => {

        let ds = await this.analizaSumeLunarePerClienti(6)
        // let rez = []

        // ds.forEach(c => {
        //     rez.push(c["client"])
        // })

        return ds;

    }

    clientiLoiali = async () => {

        let ds = await this.analizaSumeLunarePerClienti(12 * 3)
        let rez = []
        let anAnterior = new Date().getFullYear()
        let prevAnAnterior = anAnterior - 1
        let prevPrevAnAnterior = anAnterior - 2

        ds.forEach(c => {
            let inAnAnterior = c.data.filter(d => Number(d["an"]) === anAnterior)
            let inPrevAnAnterior = c.data.filter(d => Number(d["an"]) === prevAnAnterior)
            let inPrevPrevAnAnterior = c.data.filter(d => Number(d["an"]) === prevPrevAnAnterior)

            if (inAnAnterior.length !== 0 && inPrevAnAnterior.length !== 0 && inPrevPrevAnAnterior !== 0 )
                rez.push(c["client"])
        })

        return rez;
    }

    getFacturiAllNew = async() =>{
        let ds = await this.getDatasetLastMonths(24)
        let clienti = Array.from( this.getListaClientiUniciDinDataset(ds) ) ;

        let rez  = []

       

        let counter = clienti.length
        let counter2 = ds.length

       // console.log('ds :', ds);
       let facturiAll = [] 
        for(let i = 0 ; i< counter; i ++){
         
            
            for(let k = 0; k< counter2 ; k++){
                if(clienti[i]=== ds[k].localitate){
                    for(let l=k + 1; l<counter2; l++ ){
                        if(ds[l].localitate.indexOf('Total ')> -1){
                            break;
                        }
                      
                        if(ds[l].termen.indexOf('.') > -1){

                         
                       
                            let s = ds[l].termen.split('.')

                          //  console.log('s :', s);
                        if(s.length === 3){

                            // console.log('here 3 :');
                            let dataFact = new Date(s[2], s[1], s[0])

                            let dataCur = new Date()
                            ds[l].client = clienti[i]
                         
                                
                             
                            facturiAll.push(ds[l])
                            
                 
                              
                            

                        }
                        }
                        
                        
                      
                    }
                }
            }
        
        }
        return facturiAll
    }

    getFacturiNew = async () =>{
        let ds = await this.getDatasetLastMonths(24)
        let clienti = Array.from( this.getListaClientiUniciDinDataset(ds) ) ;

        let rez  = []

       

        let counter = clienti.length
        let counter2 = ds.length

       // console.log('ds :', ds);

        for(let i = 0 ; i< counter; i ++){
            let facturiInTermen =[]
        let facturiTermenDepasit = []
            
            for(let k = 0; k< counter2 ; k++){
                if(clienti[i]=== ds[k].localitate){
                    for(let l=k + 1; l<counter2; l++ ){
                        if(ds[l].localitate.indexOf('Total ')> -1){
                            break;
                        }
                      
                        if(ds[l].termen.indexOf('.') > -1){

                         
                       
                            let s = ds[l].termen.split('.')

                          //  console.log('s :', s);
                        if(s.length === 3){

                            // console.log('here 3 :');
                            let dataFact = new Date(s[2], s[1], s[0])

                            let dataCur = new Date()
                       
                         
                                facturiTermenDepasit.push(ds[l])
                            

                        }
                        
                        
                        
                    }
                    }
                }
            }
            if(facturiInTermen.length > 0 || facturiTermenDepasit.length > 0 ){

                rez.push({client:clienti[i],  facturiTermenDepasit:facturiTermenDepasit})
            }
        }
        return rez

     
        
    }
    getFacturi = async () => {
        let ds = await this.getDatasetLastMonths(24)
        let clienti = Array.from( this.getListaClientiUniciDinDataset(ds) ) ;
        
        let facturiInTermen = []
        let facturiTermenDepasit = []
         
        // console.log("analiza termene facturi: ds = ", ds)

        // console.log('ds :', ds);
        // console.log('clienti :', clienti);

let client = ''
        ds.forEach(l => {
            let t = l["termen"] || ''
      
            if( l['localitate'].indexOf('Total')=== -1  && l['termen'] === ''){
                client = l['localitate']
                // console.log('client :', client);
            }
        
            if (t.length > 0) {
                if (t.indexOf('.') > -1) {
                    let s = t.split('.')
                    if (s.length === 3) {
                        let dataFact = new Date(s[2], s[1], s[0])
                        
                        let dataCur = new Date()

                        if (dataFact.getTime() > dataCur.getTime()) {
                            
                            facturiInTermen.push({ client: l['client'], document: l['document'], termen: l['termen'], total: l['total'] } )
                        }
                        else {
                            facturiTermenDepasit.push({ client: client, document: l['document'], termen: l['termen'], total: l['total'] })
                        }
                    }
                }
            }


        })

        return {facturiInTermen, facturiTermenDepasit}
    }


    getClientiPierduti = async () => {
        let totalClienti = await this.analizaSumeLunarePerClienti(12)
        // console.log("lista total clienti este: ", totalClienti)
        
        let rez = []
        totalClienti.forEach(c => {
            let totalFacturiClient = 0
            c.data.forEach(d => {
                totalFacturiClient += Number(d['nrFacturi']) || 0
            })
            if (totalFacturiClient === 0) {
                rez.push(c["client"])
            }
        })

        // console.log("lista de clienti pierduti este: ", rez)
        return rez;
    }



    getClientiCastigati = async () => { 
        let totalClienti = await this.analizaSumeLunarePerClienti(24)
        // console.log("lista total clienti este: ", totalClienti)

        let rez = []
        let anAnterior = new Date().getFullYear()
        let prevAnAnterior = anAnterior -1 
        
        // console.log("an anterior: ", anAnterior)
        // console.log("an prev anterior: ", prevAnAnterior)

        totalClienti.forEach(c => {
            let inAnAnterior = c.data.filter(d => Number(d["an"]) === anAnterior)
            let inPrevAnAnterior = c.data.filter(d => Number(d["an"]) === prevAnAnterior)
            
            if (inAnAnterior.length !== 0 && inPrevAnAnterior.length == 0)
                rez.push(c["client"])
        })

        return rez;
    }


    getClientiLunar2 = async() =>{
        let totalClienti = await this.analizaSumeLunarePerClienti(24)

       let rez =[]



       

       return totalClienti

        // console.log('totalClienti :', totalClienti);
    }

    getClientiCastigatiLunar = async () => {
        let totalClienti = await this.analizaSumeLunarePerClienti(24)

        let rez = []
        let anAnterior = new Date().getFullYear()-1
        let prevAnAnterior = anAnterior - 2

        let dataCurenta=new Date()
        
        let lunaCurenta = dataCurenta.getMonth()
        let anCurent = dataCurenta.getFullYear()
        let rezLunaCurenta = []

        let dataLunaAnterioara1 = this.addMonths(dataCurenta, -1)
        let lunaCurentaPrev1 = dataLunaAnterioara1.getMonth()
        let anCurentPrev1 = dataLunaAnterioara1.getFullYear()
        let rezLunaCurentaPrev1 = []


        let dataLunaAnterioara2 = this.addMonths(dataCurenta, -1)
        let lunaCurentaPrev2 = dataLunaAnterioara2.getMonth()
        let anCurentPrev2 = dataLunaAnterioara2.getFullYear()
        let rezLunaCurentaPrev2 = []


        totalClienti.forEach(c => {
            let inAnAnterior = c.data.filter(d => Number(d["an"]) === anAnterior)

            if (inAnAnterior.length === 0) {

                let inLunaPrev2 = c.data.filter(d => d['an'] === anCurentPrev2 && d['luna'] === lunaCurentaPrev2)

                if (inLunaPrev2.length != 0) {
                    rezLunaCurentaPrev2.push(c)
                }

                else {

                    let inLunaPrev1 = c.data.filter(d => d['an'] === anCurentPrev1 && d['luna'] === lunaCurentaPrev1)
                    if (inLunaPrev1.length != 0) {
                        rezLunaCurentaPrev1.push(c)
                    }

                    else {
                        let inLunaCurenta = c.data.filter(d => d['an'] === anCurent && d['luna'] === lunaCurenta)
                        if (inLunaCurenta.length != 0) {
                            rezLunaCurenta.push(c)
                        }
                    }
                }
            }
        })

        return {lunaCurenta: rezLunaCurenta, lunaAnterioara: rezLunaCurentaPrev1, acum2Luni: rezLunaCurentaPrev2};
    }

    comparatieVenituriRealizatPlanificat = async (an) => {
        
        let b = await new Ws().customSelect(`select * from fin_import_bilant_rows where id_head = ( select top 1 id from fin_import_bilant_head where an = @p1 )`, { p1: an })
        let pl = await new Ws().customSelect(`select * from planificare_venituri_cheltuieli where an = @p1`, { p1: an })
        
      
        // let venituriBilant = b.Content.filter(l => l['capitol'] === 'xvi' && (l['nr_rd'] === '169' || l['nr_rd'] === '186'))
      
      //changed on 29.07.2019
         let venituriBilant = b.Content.filter(l => l['capitol'] === 'xvi' && (l['nr_rd'] === '228' ))
        
        let venituriPlanificate = pl.Content.filter(l => l['tip'] === 'Venit') 
        
        let totalVenituriBilant = 0
        venituriBilant.forEach(v => { 
            totalVenituriBilant += v['sold_final'] || 0
        })

        let totalVenituriPlanificate = 0
        venituriPlanificate.forEach(v => { 
            totalVenituriPlanificate += v['valoare'] || 0
        })

        return { totalVenituriBilant, totalVenituriPlanificate}
    }

    comparatieCheltuieliRealizatPlanificat = async (an) => {
        
        let b = await new Ws().customSelect(`select * from fin_import_bilant_rows where id_head = ( select top 1 id from fin_import_bilant_head where an = @p1 )`, { p1: an })
        let pl = await new Ws().customSelect(`select * from planificare_venituri_cheltuieli where an = @p1`, { p1: an })
        
        // let CheltuieliBilant = b.Content.filter(l => l['capitol'] === 'xvi' && (
        //     l['nr_rd'] === '186' || l['nr_rd'] === '183' || l['nr_rd'] === '188' || l['nr_rd'] === '199'
        // ))

        //changed on 29.07.2019

          let CheltuieliBilant = b.Content.filter(l => l['capitol'] === 'xvi' && (
            l['nr_rd'] === '229' 
        ))
        let CheltuieliPlanificate = pl.Content.filter(l => l['tip'] === 'Cheltuiala') 
        
        let totalCheltuieliBilant = 0
        CheltuieliBilant.forEach(v => { 
            totalCheltuieliBilant += v['sold_final'] || 0
        })

        let totalCheltuieliPlanificate = 0
        CheltuieliPlanificate.forEach(v => { 
            totalCheltuieliPlanificate += v['valoare'] || 0
        })

        return { totalCheltuieliBilant, totalCheltuieliPlanificate}
    }

    segmentareAdministratori = async () => {

        let a = await new Ws().customSelect(`select * from beneficiari_administratori`, { p1: 1 })
        if (a.Succes) {

            let sexe = new Set()
            let nrMembriiFamilie = new Set()
            let venit = new Set()
            
            let educatie = new Set()
            let ocupatie = new Set()
            let stilDeViata = new Set()

            let clasaSociala = new Set()
            let religie = new Set()
            let rasa = new Set()

            let nationalitate = new Set()
            let limba = new Set()


            a.Content.forEach(c => {
                sexe.add(c['sex'])
                nrMembriiFamilie.add(c['nr_membrii_familie'])
                venit.add(c['venit'])


                educatie.add(c['educatie'])
                ocupatie.add(c['ocupatie'])
                stilDeViata.add(c['stil_de_viata'])


                clasaSociala.add(c['clasa_sociala'])
                religie.add(c['religie'])
                rasa.add(c['rasa'])

                nationalitate.add(c['nationalitate'])
                limba.add(c['limba'])

            })


            let rezSexe = []
            let rezNrMembriiFamilie = []
            let rezVenit = []

            let rezEducatie = []
            let rezOcupatie = []
            let rezStilDeViata = []

            let rezClasaSociala = []
            let rezReligie = []
            let rezRasa = []

            let rezNationalitate = []
            let rezLimba = []

            sexe.forEach(el => {
                let _c = a.Content.filter(adm => adm['sex'] === el)
                rezSexe.push({sex:el,clienti:_c})
            })
            nrMembriiFamilie.forEach(el => {
                let _c = a.Content.filter(adm => adm['nr_membrii_familie'] === el)
                rezNrMembriiFamilie.push({ nrMembrii: el, clienti: _c })
            })
            venit.forEach(el => {
                let _c = a.Content.filter(adm => adm['venit'] === el)
                rezVenit.push({ venit: el, clienti: _c })
            })

            educatie.forEach(el => {
                let _c = a.Content.filter(adm => adm['educatie'] === el)
                rezEducatie.push({ educatie: el, clienti: _c })
            })

            ocupatie.forEach(el => {
                let _c = a.Content.filter(adm => adm['ocupatie'] === el)
                rezOcupatie.push({ ocupatie: el, clienti: _c })
            })


            stilDeViata.forEach(el => {
                let _c = a.Content.filter(adm => adm['stil_de_viata'] === el)
                rezStilDeViata.push({ stil: el, clienti: _c })
            })

            clasaSociala.forEach(el => {
                let _c = a.Content.filter(adm => adm['clasa_sociala'] === el)
                rezClasaSociala.push({ clasa: el, clienti: _c })
            })

            religie.forEach(el => {
                let _c = a.Content.filter(adm => adm['religie'] === el)
                rezReligie.push({ religie: el, clienti: _c })
            })

            rasa.forEach(el => {
                let _c = a.Content.filter(adm => adm['rasa'] === el)
                rezRasa.push({ rasa: el, clienti: _c })
            })

            nationalitate.forEach(el => {
                let _c = a.Content.filter(adm => adm['nationalitate'] === el)
                rezNationalitate.push({ nationalitate: el, clienti: _c })
            })

            limba.forEach(el => {
                let _c = a.Content.filter(adm => adm['limba'] === el)
                rezLimba.push({ limba: el, clienti: _c })
            })
            
            
            return {
                sexe: rezSexe,
                nrMembriiFamilie: rezNrMembriiFamilie,
                venit: rezVenit,
                educatie: rezEducatie,
                ocupatie: rezOcupatie,
                stilDeViata: rezStilDeViata,
                clasaSociala: rezClasaSociala,
                religie: rezReligie,
                rasa: rezRasa,
                nationalitate: rezNationalitate,
                limba:rezLimba
            }
        }
    }

    
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////// ///// /////                                                          functii comune si de calcul
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    getMonthData = async (an, luna) => {
        let ws = new Ws()
        let s = await ws.customSelect(`select * from pm.[dbo].fin_import_raport_lunar_clienti_rows where id_head in ( select id from pm.[dbo].fin_import_raport_lunar_clienti_head where an=@an and luna=@luna )`, { an: an, luna: luna })
        if(s.Succes)
            return s.Content
        else
            throw new Error(`Err get luna analizata ${luna} si an ${an} : ${s.Messsage}`)
    }

    getDatasetLastMonths = async (nr = null) => {
        
        let n = nr !== null ? nr : 12

        let rez = []
        //let dataCurenta = new Date();
        
        
        
        
        for (let i = 0; i < n; i++){
            
            //incepem de la luna anterioara:
            let dataCurenta = this.addMonths(new Date(), -1)

           
            let dataLunaTrecuta = this.addMonths(dataCurenta , -1 * i )

            let an = dataLunaTrecuta.getFullYear()
            let luna = 1+  dataLunaTrecuta.getMonth()

            let dateLuna = await this.getMonthData(an, luna)
            
            dateLuna.forEach(toAdd => {
                toAdd['an'] = an
                toAdd['luna'] = luna

                rez.push(toAdd)
            });
        }

        return rez;
    }

   

    analizaSumeLunarePerClienti = async (nrOfMonthsAnalized) => {
        let ds = await this.getDatasetLastMonths(nrOfMonthsAnalized)
        // console.log(' ... ds ... ', ds)

        let clienti = Array.from( this.getListaClientiUniciDinDataset(ds) ) ;
        let ani = Array.from( this.getListaAniUniciDinDataset(ds) ) ;
        let luni = Array.from(this.getListaLuniUniceDinDataset(ds));

        clienti = clienti.sort((a,b) => {
            if (String(a) < String(b)) { return -1; }
            return 1;
        })
        
        ani = ani.sort((a, b) => {
            if (Number(a) < Number(b)) { return 1; }
            return -1;
        })

        luni = luni.sort((a, b) => {
            if (Number(a) < Number(b)) { return 1; }
            return -1;
        })

        // console.log("clienti = ", clienti)
        // console.log("ani = ", ani)
        // console.log("luni = ", luni)

        let rez = []

        clienti.forEach(c => { 
                ////
                // console.log("analizam clientul: ", c)
            let _nume = c;
            let _an = 0;
            let _luna = 0;
            let _nrFacturi = 0;
            let _totalDeIncasat = 0;
            let cData = []

            ani.forEach(an => {
              
                luni.forEach(l => {

                    
                    let liniiFiltrate = ds.filter(li => (li["localitate"].indexOf(c) > -1 && li["localitate"].indexOf("Total") == -1) && li["an"] == an && li["luna"] == l)
                    _nrFacturi = liniiFiltrate.length
                    
                    let linieTotal = ds.filter(li => (li["localitate"].indexOf(c) > -1 && li["localitate"].indexOf("Total ") > -1) && li["an"] == an && li["luna"] == l)
                    if (linieTotal.length > 0) {
                        _totalDeIncasat = linieTotal[0]["total"] || 0
                    }
                    else
                        _totalDeIncasat = 0

                    cData.push({ an: an, luna: l, nrFacturi: _nrFacturi, totalDeIncasat: _totalDeIncasat })
                 })
            })

            rez.push({client:c, data:cData })
        })

        // console.log("-- gata analize sume lunare pe clienti", rez)
        return rez;

    }

    getListaClientiUniciDinDataset = (ds) => {
        let rez = new Set();
        ds.forEach(c => {
            
            if (c['localitate'].indexOf('Total ') > -1) {
                rez.add(c['localitate'].replace('Total ',''))
            }
        })
        return rez;
    }

    getListaAniUniciDinDataset = (ds) => { 
        let rez = new Set()
        ds.forEach(c => {
            rez.add(c.an)
        })
        return rez;
    }

    getListaLuniUniceDinDataset = (ds) => {
        let rez = new Set()
        ds.forEach(c => {
            rez.add(c.luna)
        })
        return rez;
    }


    addMonths = (dt, n) => {
        return new Date(dt.setMonth(dt.getMonth() + n));
    }
}